import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
// import {
//   GetOrderCartable,
//   GetOrderStateForCartable,
// } from "../../services/store.service";
// import {
//   GetOrderCartableResponse,
//   GetOrderStateForCartableReponse,
// } from "../../models/store.model";
import { createStyles, makeStyles } from "@material-ui/core";
import {
  Box,
  Grid,
  Modal,
  Pagination,
  PaginationItem,
  Typography,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
// import { Filter, PaginationInfo } from "../../models/cartable.model";
// import { Unstable_Popup as BasePopup } from "@mui/base/Unstable_Popup";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// import StoreManagementModal from "./storeManagementModal";
// import { useOutsideClick } from "../../hook/useOutsideClick";
// import { STORESTATE } from "../../config/cacheKey";
// import TableRowSkeleton from "../../components/skeletons/TableRowSkeleton";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { toast } from "react-toastify";
import TableRowSkeleton from "../../components/skeletons/TableRowSkeleton";
import { PaginationInfo } from "../../models/loan.model";
import { GetWhiteListCustomersResponse } from "../../models/loanTemplateWhiteList.model";
import {
  DeleteWhiteListCustomer,
  GetWhiteListCustomers,
} from "../../services/loanTemplateWhiteList.service";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};
let muiSelected: any;

const WhiteListCostumersTable = () => {
  const jsonFile = useSelector((state: any) => state.style);
  muiSelected = jsonFile?.muiSelected;

  const [data, setData] = useState<GetWhiteListCustomersResponse[]>([]);

  const [selectedRow, setSelectedRow] = useState(undefined);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [delId, setDelId] = useState<{ id: number; name: string }>();

  const [pageInfo, setPageInfo] = useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );

  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      return paginationInfo;
    }
  );

  const classes = useStyles();

  const columns: readonly ColumnModel[] = [
    { id: "customerFirstName", label: "نام و نام خانوادگی" },
    { id: "customerNationalCode", label: "کد ملی" },
    { id: "supplierTitle", label: "نام پذیرنده" },
    {
      id: "registerDate_Persian",
      label: "تاریخ ثبت",
    },
    { id: "hasRegisteredLoan", label: "تسهیلات اعطا شده" },
    {
      id: "monthlyRepaymentPower",
      label: "توان بازپرداخت ماهیانه (ریال)",
      hasFormat: true,
      format: (value: number) => {
        return value.toLocaleString("fa");
      },
    },
    { id: "loanTemplateTitle", label: "نام طرح ثبت نام شده" },
  ];

  const nextIcon = () => {
    return (
      <img
        style={{ height: "12px", width: "10px" }}
        src="images/Next.png"
        alt="next"
      />
    );
  };
  const previusIcon = () => {
    return (
      <img
        style={{ height: "12px", width: "10px" }}
        src="images/Previous.png"
        alt="previous"
      />
    );
  };

  // services

  const changePageNumber = (newPageNumber: number) => {
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
    GetWhiteListCustomersMutate({
      pageNumber: currentPaginationInfo.pageNumber!,
      pageSize: 10,
    });
  };

  const handleSelectRow = (rowIndex: any) => {
    setSelectedRow(rowIndex);
  };

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    handleSelectRow(undefined);
  };

  const { mutate: GetWhiteListCustomersMutate, isLoading } = useMutation(
    GetWhiteListCustomers,
    {
      onSuccess: (res: ApiResultModel<GetWhiteListCustomersResponse[]>) => {
        if (res) {
          if (res) {
            setData(res.data);
            setPageInfo(res.pageInfo);
          }
        }
      },
      onError: () => {},
    }
  );
  const { mutate: DeleteWhiteListCustomerMutate } = useMutation(
    DeleteWhiteListCustomer,
    {
      onSuccess: (res: boolean) => {
        if (res) {
          if (res) {
            setOpenDeleteModal(false);
            toast.success("مجوز با موفقیت حذف شد");
            GetWhiteListCustomersMutate({
              pageNumber: currentPaginationInfo.pageNumber!,
              pageSize: 10,
            });
          }
        }
      },
      onError: () => {},
    }
  );

  useEffect(() => {
    GetWhiteListCustomersMutate({
      pageNumber: currentPaginationInfo.pageNumber!,

      pageSize: 10,
    });
  }, []);

  return (
    <>
      <div>
        <div className="cardTableBorder">
          <TableContainer
            style={{
              background: "#fff",
              maxHeight: "70vh",
              flexGrow: "1",
              overflow: "auto",
              overflowX: "hidden",
              // maxHeight: "1%",
              flexDirection: "column",
              /* padding-right: 3vh; */
              direction: "rtl",
              height: "75vh",
            }}
            //   className="boxScroll"
          >
            <Table
              stickyHeader
              aria-label="sticky table"
              style={{ borderCollapse: "collapse" }}
            >
              <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
                <TableRow
                  classes={{ root: classes.select }}
                  className={`${classes} borderRight borderLeft`}
                  selected={selectedRow === 0}
                >
                  {columns.map((column) => (
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight noWrap"
                      key={column.id}
                      align="right"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight"
                    align="right"
                    style={{ width: "10vh", minWidth: "10vh" }}
                  >
                    <MoreHorizIcon />
                  </TableCell>
                </TableRow>
              </TableHead>
              <div style={{ width: "100%", height: "10px" }}></div>
              <TableBody>
                {!isLoading ? (
                  data ? (
                    data.map((row, rowIndex) => {
                      return (
                        <TableRow
                          classes={{ root: classes.select }}
                          className={`${
                            rowIndex % 2 === 0 ? "rowTBodyE  " : "rowTBodyO "
                          } ${classes} borderRight borderLeft noWrap`}
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                          selected={selectedRow === rowIndex}
                          sx={{ height: "70px" }}
                        >
                          {columns.map((column) => {
                            const value =
                              row[
                                column.id as keyof GetWhiteListCustomersResponse
                              ];

                            return (
                              <>
                                <TableCell
                                  className="textFont12"
                                  key={column.id}
                                  align="right"
                                  sx={{
                                    color:
                                      column.id === "hasRegisteredLoan"
                                        ? row.hasRegisteredLoan === true
                                          ? "#01AF43"
                                          : "#E6123D"
                                        : "",
                                  }}
                                >
                                  {column.id === "hasRegisteredLoan"
                                    ? row.hasRegisteredLoan === true
                                      ? "بله"
                                      : "خیر"
                                    : column.format && column.hasFormat
                                    ? column.format(value)
                                    : value?.toString()}

                                  {column.id === "customerFirstName" &&
                                    " " + row.customerLastName}
                                </TableCell>
                              </>
                            );
                          })}
                          <TableCell
                            onClick={() => {
                              setOpenDeleteModal(true);
                              setDelId({
                                id: row.id,
                                name:
                                  row.customerFirstName +
                                  " " +
                                  row.customerLastName,
                              });
                            }}
                            sx={{ cursor: "pointer" }}
                            className="textFont12"
                            align="right"
                          >
                            <DeleteOutlineIcon />
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : null
                ) : (
                  <TableRowSkeleton rowsNum={10} columnsNum={8} width={120} />
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div>
          <div className="row"></div>
          <Grid container xs={12}>
            <Grid item xs={4}>
              <span
                style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
              >
                تعداد کل :
                <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
              </span>
            </Grid>
            <Grid item xs={4}>
              <Pagination
                renderItem={(item) => (
                  <PaginationItem
                    components={{
                      previous: previusIcon,
                      next: nextIcon,
                    }}
                    {...item}
                  />
                )}
                sx={{
                  display: "flex",
                  justifyContent: "center !important",
                  direction: "ltr",
                  margin: "5px",
                  button: {
                    color: "#25D1C9",
                    fontSize: "14px !important",
                    fontFamily: "iranSans",
                  },
                }}
                count={
                  pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
                }
                onChange={handleChangePagination}
                page={currentPaginationInfo.pageNumber}
              />
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>
        </div>
      </div>
      <div>
        <Modal
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            {/* <Box position={"relative"}>
              <Typography
                onClick={() => setOpenDeleteModal(false)}
                component={"p"}
                color={"red"}
                position={"absolute"}
                top={0}
                left={0}
                sx={{ cursor: "pointer" }}
              >
                <CloseIcon></CloseIcon>
              </Typography>
            </Box> */}
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"center"}
              fontWeight={"bold"}
              marginY={"3rem"}
              fontSize={"14px"}
            >
              {/* آیا از <span style={{ color: "#E6123D" }}>حذف کردن </span>
              این
              <span style={{ color: "#E6123D" }}> کاربر </span> اطمینان دارید؟ */}
              آیا از حدف مجوز{" "}
              <span style={{ color: "#E6123D" }}>{delId?.name}</span> اطمینان
              دارید؟
            </Typography>
            <Grid container justifyContent={"center"} gap={"1rem"}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#E6123D",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  onClick={() => {
                    DeleteWhiteListCustomerMutate({
                      id: delId!.id,
                    });
                  }}
                >
                  حذف
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#607D8B",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  onClick={() => setOpenDeleteModal(false)}
                >
                  انصراف
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default WhiteListCostumersTable;
